import { Component, computed, inject, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { HotelSummaryModel } from '@core/models/domains/hotel';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
  selector: 'iho-abouthotel-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './abouthotel-modal.component.html',
  styleUrls: ['./abouthotel-modal.component.scss'],
})
export class AbouthotelModalComponent implements OnInit {
  private searchBoxService = inject(SearchBoxService);
  accommodation = computed(() => this.searchBoxService.accommodation());
  
  modalData: HotelSummaryModel

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { aboutHotelData: HotelSummaryModel },
    public dialogRef: MatDialogRef<AbouthotelModalComponent>
  ){
    this.modalData = data.aboutHotelData
  }

  ngOnInit(): void {
  }

  closeModal() {
    this.dialogRef.close();

  }

}
